import React from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import { setDateFormat } from '../../../../../lib/moment';
import { PRODUCT_REJECT_TYPE_TEXT } from '../../../../../constants/service/app/productConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';

const RejectReasonListModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { rejectReasonList = [] } = data;

  return (
    <Modal
      title="거절 사유 리스트"
      isOpen={isOpen}
      width={760}
      height={300}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="reject-reason-list-modal">
        <InfoTable>
          <thead>
            <tr>
              <th>요청 일시</th>
              <th>처리 일시</th>
              <th>거절 타입</th>
              <th>거절 사유</th>
            </tr>
          </thead>
          <tbody>
            {rejectReasonList.map((item, index) => (
              <tr key={index}>
                <td className="tc">{setDateFormat(item.createDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
                <td className="tc">{setDateFormat(item.confirmDate, DATE_FORMAT.YMD_DASH_FORMAT)}</td>
                <td className="tc">{PRODUCT_REJECT_TYPE_TEXT[item.type]}</td>
                <td className="tc">{item.reason}</td>
              </tr>
            ))}
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default RejectReasonListModal;
